import React from "react";

import { Box, Card, Typography } from "@mui/material";

import CircleButton from "design-system/components/CircleButton";
import { grayDark, white } from "design-system/colors";
import { MessageIcon, PhoneIcon } from "design-system/icons";
import { formatPhoneNumber } from "utils/phoneNumberFormatter/phoneNumberFormatter";
import { Driver } from "types";

type DriverCardProps = {
  driver: Driver | null;
};

function DriverCard(props: DriverCardProps) {
  const { driver } = props;

  if (!driver) {
    return (
      <Card variant="outlined">
        <Box display="flex" flexDirection="column" my={2} mx={3}>
          <Box mb={2}>
            <Typography variant="h3">Driver</Typography>
          </Box>
          <Box display="flex" flexDirection="column">
            <Typography variant="h6" sx={{ lineHeight: 1.35 }}>
              Not assigned yet
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5, color: grayDark }}>
              Driver contact will appear here once assigned.
            </Typography>
          </Box>
        </Box>
      </Card>
    );
  }

  // derived state
  const driverName = [driver.firstName, driver.lastName]
    .filter(Boolean)
    .join(" ");
  const driverPhone = driver.mobilePhone
    ? formatPhoneNumber(driver.mobilePhone).formatted
    : "";
  const driverPhoneLink = driver.mobilePhone
    ? formatPhoneNumber(driver.mobilePhone)?.e164
    : "";

  return (
    <Card variant="outlined">
      <Box display="flex" flexDirection="column" my={2} mx={3}>
        <Box mb={2}>
          <Typography variant="h3">Driver</Typography>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box pr={2}>
            <Typography variant="h6" sx={{ lineHeight: 1.35 }}>
              {driverName}
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              {driverPhone || "-"}
            </Typography>
          </Box>
          <Box display="flex" flexDirection="row" flexShrink={0}>
            <Box mr={1.5}>
              <CircleButton
                disabled={!driverPhoneLink}
                component="a"
                href={`sms:${driverPhoneLink}`}
              >
                <MessageIcon color={white} />
              </CircleButton>
            </Box>
            <CircleButton
              disabled={!driverPhoneLink}
              component="a"
              href={`tel:${driverPhoneLink}`}
            >
              <PhoneIcon color={white} />
            </CircleButton>
          </Box>
        </Box>
      </Box>
    </Card>
  );
}

export default DriverCard;
